'use strict';

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '</button>' + message + '</div>';

    $('.gift-card-error').append(errorHtml);
}
$(document).ready(function () {
    $('body').on('click', '.giftcertcode-button-balance', function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.giftcert-message').hide();
        $('.gift-cert-missing-error').hide();
        $('.certificate-error-message').hide();
        if (!$('.giftcert-input-field').val()) {
            $('.gift-cert-missing-error').show();
            $.spinner().stop();
            return false;
        }

        var $giftcertcode = $('.giftcert-input-field').val();

        $.ajax({
            url: $('.giftcert-input-field').attr('data-gift-cert-add'),
            type: 'GET',
            dataType: 'json',
            data: 'giftCertCode=' + $giftcertcode,
            success: function (data) {
                if (data.error) {
                    $('.certificate-error-message').empty().show().append(data.errorMessage);
                    $.spinner().stop();
                } else {
                    var giftCertHtml = '';
                    if (data.balanceValue == -1) {
                        $('.certificate-error-message').empty().show().append(data.message);
                    } else {
                        giftCertHtml += '<div class="gift-' + $giftcertcode + ' gift-cert-list"><span>' + $('.js-gift-result-label').data('label') + '</span><span class="float-right"><span>$' + data.balanceCurrency + '</span><span class="gift-cert-price">' + data.balanceValue.toFixed(2) + '</span></span></div>';
                        $('.giftcert-message').empty().show().append(giftCertHtml);
                    }
                    $.spinner().stop();
                }
            },
            error: function (err) {
                createErrorNotification(err.errorMessage);
                $.spinner().stop();
            }
        });
    });
});
